import { authFetch } from './http/fetchClient';
import { APIUrl } from 'Utils/Utils';

export interface UploadedFileRecord {
  file_id: string;
  original_filename: string;
  file_extension: string;
  file_size_bytes: number;
}

export const fileUploadApi = {
  listFiles: async (sessionId: string, signal?: AbortSignal): Promise<UploadedFileRecord[] | null> => {
    const params = new URLSearchParams({ session_id: sessionId });
    const res = await authFetch(`${APIUrl()}/chat_file_upload/file?${params}`, { signal });
    if (!res.ok) return null;
    return res.json();
  },

  uploadFile: async (file: File, sessionId: string): Promise<{ file_id: string } | null> => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('session_id', sessionId);
    const res = await authFetch(`${APIUrl()}/chat_file_upload/file`, {
      method: 'POST',
      body: formData,
    });
    if (!res.ok) return null;
    return res.json();
  },

  deleteFile: async (fileId: string, sessionId: string): Promise<boolean> => {
    const params = new URLSearchParams({ session_id: sessionId });
    const res = await authFetch(`${APIUrl()}/chat_file_upload/file/${fileId}?${params}`, {
      method: 'DELETE',
    });
    return res.ok;
  },
};
